module.exports = __webpack_public_path__ + "static/img/java1.c1197c93.png";